import ListGroup from 'react-bootstrap/ListGroup';
import { OpinionItem } from '../OpinionItem';
import { OpinionModel } from '../Opinion.hooks';
import { Stock } from 'components/Stock/Stock.helper';
import { useOpinionsQuery } from '../OpinionCol/OpinionCol.hooks';
import { UserContext } from 'components/UserContext';
import { useContext } from 'react';

export type OpinionItemListProps = {
  stock: Stock;
  direction: 'up' | 'down';
};

export const OpinionItemList = ({ stock, direction }: OpinionItemListProps) => {
  const { data: opinions = [] } = useOpinionsQuery({ stock, direction });
  const { user } = useContext(UserContext);
  const directionText = direction === 'up' ? '상승' : '하락';

  return opinions.length > 0 ? (
    <ListGroup>
      {opinions.map((opinion: OpinionModel) => {
        return (
          <OpinionItem
            key={opinion.createdAt.toDate().getTime()}
            canRead={user ? user.canReadArticles : false}
            isShowDirection={false}
            isShowStock={false}
            {...opinion}
          />
        );
      })}
    </ListGroup>
  ) : (
    <p className="text-muted">
      아직 의견이 없습니다.
      <br />
      {directionText}에 대한 첫 의견을 남겨보세요 :)
    </p>
  );
};
